module.exports = __webpack_public_path__ + "img/zoom.4950e7fb.svg";